import React from 'react';
import './index.less'
import { RouteComponentProps } from 'react-router-dom';
import { GetQueryString } from 'utils';
import { GetQueryStringByUrl } from '../../../utils/index';
import api from 'api';

export default class extends React.Component<RouteComponentProps> {

  ref = React.createRef<HTMLIFrameElement>();

  render() {
    let id = GetQueryString('id') || '';
    let voucherPath = GetQueryString('voucherPath') || '';
    if (id === '') return <React.Fragment />
    return (
      <img className="rint-img" src={`/images/${voucherPath}/${id}.jpg`}></img>
      // <img className="rint-img" src={decodeURIComponent(GetQueryString('contractImgageUrl') || '')}></img>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/interface/voucher/PrintContent.tsx